import React, { useState, useEffect } from "react";
import MainImage from "../Components/MainImage";
import im from "../Media/pics.png";
import {
  Typography,
  Box,
  Stack,
  useMediaQuery,
  Container,
} from "@mui/material";
import SmallBtns from "../Components/SmallBtns";
import MiniCards from "../Components/MiniCards";
import k from "../Media/car (1).png";
import k2 from "../Media/Polygon 3.png";
import k3 from "../Media/safe.png";
import OurGoal from "../Components/OurGoal";
import kk from "../Media/TGM_04501_2dd593a0ac_jpg_1_d656a59d85.png";
import AboutUs from "../Components/AboutUs";
import kk2 from "../Media/Annotation 2023-09-28 152626.png";
import db from "../DbFile.json";
import ServicesCard from "../Components/ServicesCard";
import Questions from "../Components/Questions";
import { useTranslation } from "react-i18next";

export default function SchoolRides({ setTheState }) {
  const matches = useMediaQuery("(min-width:410px)");
  const [el, setEl] = useState(db.first_array);
  const [Qs, setQs] = useState(db.SRide_Q);
  const { t } = useTranslation();
  useEffect(() => {
    setTheState(false);
  }, []);
  return (
    <div>
      <MainImage
        image={im}
        txt1={"Custom school trips"}
        txt2={"For Your Lettle Once"}
        btxt={"Book your ride"}
      />
      <Container>
        <Box
          sx={{
            marginTop: "3%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
          >
            {t("Students transportation")}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "#1D2877", fontSize: "20px" }}>
            {t(
              "with just a tap , you can order a school rides that`s exclusively customized to meet yours and your child`s needs."
            )}
          </Typography>
        </Box>
        <br />
        <br />

        <Stack
          direction={matches ? "row" : "column"}
          gap={4}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <SmallBtns
            txt={"Classic"}
            name={"GoAnyWhere"}
            scrollTarget="classic"
          />
          <SmallBtns txt={"VIP"} name={"GoAnyWhere"} scrollTarget="vip" />
          <SmallBtns txt={"Van"} name={"GoAnyWhere"} scrollTarget="van" />
          <SmallBtns txt={"School Rides"} name={"SchoolRides"} />
        </Stack>
        <br />
        <br />
        <br />

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "60px",
          }}
        >
          <MiniCards
            imgg={k}
            txt={"Book Trip"}
            txt2={
              "Select from a wide range of options and get your ride within minutes, or schedule one for later."
            }
          />
          <MiniCards
            imgg={k3}
            txt={"Your kids are in the safest hands"}
            txt2={
              "they are being looked after by our team who prioritize their safety."
            }
          />
        </div>
      </Container>
      <OurGoal
        im={kk}
        caption={"Let us take care of it."}
        btn={"Book your ride"}
        txt={
          "Our newest feature , School Rides , will help you say goodbye to running after your kids in the morning or struggling to arrange pickups and drop-offs ."
        }
      />

      <AboutUs
        caption={"school transportation services"}
        txt={
          "we offer a safe, reliable, and convenient mode of transportation for students"
        }
        pic={kk2}
        btn={"Book your ride"}
      />
      <br />
      <br />
      <Container>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "#1D2877", fontSize: "30px", fontWeight: "bold" }}
          >
            {t("Explore more with Mashawiri")}
          </Typography>
        </Box>
        {el && <ServicesCard el={el.filter((el) => el.id > 1)} />}
      </Container>
      <Questions questions={Qs} />
    </div>
  );
}
